module.exports = __webpack_public_path__ + "img/m7.0dd95755.png";